interface MultiEditToolbarProps {
  selectedCount: number,
  onMultiEdit: () => void
  onClearSelection: () => void
}

export default function MultiEditToolbar({
  selectedCount,
  onMultiEdit,
  onClearSelection
}: MultiEditToolbarProps) {
  if (selectedCount === 0) {
    return null
  }

  return (
    <div className="multi-edit-toolbar">

      {/* Selected Count */}
      <span>
        {selectedCount} device{selectedCount > 1 ? 's' : ''} selected
      </span>

      {/* Edit device Button */}
      <button
        className="multi-edit-btn btn btn-primary"
        onClick={onMultiEdit}
      >
        {selectedCount === 1 ? 'Edit Device' : 'Multi Edit'}
      </button>

      {/* Clear Selection Button */}
      <button
        className="clear-selection-btn btn btn-secondary"
        onClick={onClearSelection}
      >
        Clear Selection
      </button>

    </div>
  )
}